module.exports = __webpack_public_path__ + "static/img/portrait.8b95680.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portrait.png
// module id = ycxP
// module chunks = 2